export enum FranceIdType {
  PASSPORT = 'passport',
  NTT = 'ntt',
  NIA = 'nia',
  NIR = 'nir',
}
